import React from 'react';
import { Box, Container, Typography, Button, Link } from '@mui/material';
import ClassificationBannerHeader from '../../common/banner/classifactionBannerHeader';
import PageHeader from '../../common/banner/pageHeader';
import EmassDashboard from '../../common/buttons/emassDash';

export default function AOScorecard() {

  const baseRoute = process.env.REACT_APP_BASE_RpmOUTE || '/';
  const imgRoute = 'images/analytics/ao-scorecard.png';
  const route = baseRoute + imgRoute;
  
  return (
    <Container sx={{ minWidth:1800, mt: 10, mb: 10 }}>
      <Box sx={{pt: 2}}>
        <ClassificationBannerHeader></ClassificationBannerHeader>
        <PageHeader title="CCG Dashboards"></PageHeader>
      </Box>
      <Typography variant='h4' 
        sx ={{display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center', 
              fontSize: '1.35em', 
              marginBottom: '10px'}}>
        AO Scorecard
      </Typography>
      <EmassDashboard></EmassDashboard>
      <Box
        sx={{          
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column'
        }}
      >
      <img 
          alt="PM Info"
          src={route}
          width="100%"
          height="100%"
          style={{ border: 'none', display: 'flex', objectFit: 'none', marginTop: '-40px', marginBottom: '-50px' }}
      />
      </Box>
    </Container>
  );
};